if (!customElements.get("video-with-articles")) {
  class VideoWithArticles extends HTMLElement {
    constructor() {
      super();
      this.mainVideo = this.querySelector(".main-video-container video");
      this.customPlayBtn = this.querySelector(".main-video-container svg");
      this.boundPlayMainVideo = this.playMainVideo.bind(this);
      this.boundHandleVideoPause = this.handleVideoPause.bind(this);
      this.articleSliderEl = this.querySelector(".article-slider");
      this.ytSliderEl = this.querySelector(".yt-slider");
      this.sectionId = this.dataset.sectionId;
    }

    connectedCallback() {
      if (this.customPlayBtn) {
        this.customPlayBtn.addEventListener("click", this.boundPlayMainVideo);
        this.mainVideo.addEventListener("pause", this.boundHandleVideoPause);
      }

      if (window.innerWidth <= 991) {
        this.waitForSwiper(() => {
          this.initArticleSlider();
          this.initYtSlider();
        });
      }
    }

    waitForSwiper(callback) {
      if (typeof window.Swiper !== "undefined") {
        callback();
      } else {
        var check = setInterval(function () {
          if (typeof window.Swiper !== "undefined") {
            clearInterval(check);
            callback();
          }
        }, 50);
      }
    }

    disconnectedCallback() {
      if (this.customPlayBtn) {
        this.customPlayBtn.removeEventListener(
          "click",
          this.boundPlayMainVideo
        );
        this.mainVideo.removeEventListener("pause", this.boundHandleVideoPause);
      }
    }

    playMainVideo() {
      if (this.mainVideo) {
        this.customPlayBtn.style.display = "none";
        this.mainVideo.setAttribute("controls", "");
        this.mainVideo.play();
      }
    }

    handleVideoPause() {
      this.mainVideo.removeAttribute("controls");
      this.customPlayBtn.style.display = "block";
    }

    initArticleSlider() {
      const paginationEl = this.querySelector(".swiper-pagination-articles");

      this.articleSlider = new Swiper(this.articleSliderEl, {
        slidesPerView: 1,
        spaceBetween: 8,
        mousewheel: {
          releaseOnEdges: true,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        navigation: {
          nextEl: `.swiper-icon-right#swiper-right-article-${this.sectionId}`,
          prevEl: `.swiper-icon-left#swiper-left-article-${this.sectionId}`,
        },
      });
    }

    initYtSlider() {
      const paginationEl = this.querySelector(".swiper-pagination-yt");

      this.ytSlider = new Swiper(this.ytSliderEl, {
        slidesPerView: 1,
        spaceBetween: 8,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        navigation: {
          nextEl: `.swiper-icon-right#swiper-right-yt-${this.sectionId}`,
          prevEl: `.swiper-icon-left#swiper-left-yt-${this.sectionId}`,
        },
      });
    }
  }

  customElements.define("video-with-articles", VideoWithArticles);
}
